import * as React from "react";
import styled from "styled-components";
import { SortableTree } from "dnd-kit-sortable-tree";
import { Category } from "./Category";
import type { CategoryNode } from "@iterate/common/types/shared";
import { CategoryContext } from "./CategoryContext";
import { Tree } from "src/utils/Tree";

interface Props {
  categories: CategoryNode[];
  onEditCategory(category: CategoryNode): void;
  onChangeCategories(fn: (categories: CategoryNode[]) => void): void;
  onCreateChildCategory(parent: CategoryNode): void;
}

export function CategoriesEditor({
  categories,
  onChangeCategories,
  onEditCategory,
  onCreateChildCategory,
}: Props) {
  const deleteCategory = (category: CategoryNode) => {
    onChangeCategories((categories: CategoryNode[]) => {
      Tree.deleteNode(categories, category.id);
    });
  };

  const updateCategory = (category: CategoryNode) => {
    onChangeCategories((categories: CategoryNode[]) => {
      Tree.updateNode(categories, category);
    });
  };
  return (
    <Container>
      <Categories>
        <CategoryContext.Provider
          value={{
            editCategory: onEditCategory,
            updateCategory,
            createChildCategory: onCreateChildCategory,
            deleteCategory,
          }}
        >
          <SortableTree
            items={categories}
            onItemsChanged={(categories) => onChangeCategories(() => categories)}
            TreeItemComponent={Category}
            sortableProps={{ animateLayoutChanges: () => false }}
            dropAnimation={null}
            indentationWidth={30}
          />
        </CategoryContext.Provider>
      </Categories>
    </Container>
  );
}

const Container = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

const Categories = styled.div`
  flex-grow: 1;
  max-width: 600px;
`;
